<template>
  <div class="v-radio">
    <input
      class="v-radio-control"
      :id="id"
      :name="name"
      type="radio"
      :value="value"
      :checked="isChecked"
      @input="onInput"
      @change="onChange"
    />
    <label v-if="label" class="v-radio-label" :for="id">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: "BaseRadio",
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    uncheckedValue: {
      type: [Boolean, String],
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    }
  },
  methods: {
    onInput(event) {
      this.$emit("update:modelValue", event.target.value);
    },
    onChange(event) {
      let isChecked = event.target.checked;
      this.$emit("change", isChecked ? this.value : this.uncheckedValue);
    }
  },
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    }
  }
};
</script>
